import { jsx as e } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import { twMerge as n } from "tailwind-merge";
import { FONT_SIZE_CLASS_NAME as m } from "../../../constants/base-class-name.mjs";
const d = p(
  ({ children: o, style: r, optionsClassName: t, as: a, optionsProps: i }, s) => /* @__PURE__ */ e(
    a,
    {
      anchor: { to: "bottom", gap: 4 },
      portal: !0,
      transition: !0,
      ref: s,
      style: r,
      className: n(
        "h-full w-[var(--input-width)] min-w-[200px]",
        "bg-background-secondary shadow-around-sm rounded-lg",
        "z-20",
        "data-[closed]:opacity-0 transition duration-200 ease-out empty:invisible",
        "customScroll",
        m,
        t
      ),
      ...i,
      children: o
    }
  )
);
d.displayName = "ListOptionsWrapper";
export {
  d as ListOptionsWrapper
};
